module.exports = __webpack_public_path__ + "static/media/waiting.c50a472e.svg";